module.exports = __webpack_public_path__ + "static/slingshot-4eab9faa7b057e2e13d1357a88b08b06.png";